import React from "react";
import ConnectionFormDialog from "../../../components/forms/ConnectionFormDialog";
import FormSelectField from "../../../components/forms/fields/basic/SelectField";
import FormTextField from "../../../components/forms/fields/basic/TextField";
import FormEntitySelectionField from "../../../components/forms/fields/basic/EntitySelectionField";
import { IntellexusDateField } from "../../forms/common/intellexusDate/IntellexusDateField";
import { Version } from "../../../types/version";
import { Team } from "../../../types/team";
import { Place } from "../../../types/place";
import { SystemEntityCollections } from "../../../shared/enums/shared-enums";
import { ConnectionFormDataController } from "../../../controllers/formController";
import {
  SystemTeamContributionTypes,
  VersionTeamConnection,
} from "../../../types/versionTeam";
import renderTeamSelection from "../../../components/entitiesReferences/SelectionModals/TeamSelectionModal";
import renderPlaceSelection from "../../../components/entitiesReferences/SelectionModals/PlaceSelectionModal";
import renderVersionSelection from "../../../components/entitiesReferences/SelectionModals/VersionSelectionModal";
import { SystemLanguages } from "../../../shared/enums/shared-enums";
import RevisionList from "./RevisionList";
import useVersionTeamConnectionLogic from "../../../hooks/logic/connections/versionTeamConnectionLogic";

interface VersionTeamDialogProps {
  controller: ConnectionFormDataController<VersionTeamConnection, Version, Team>;
  versionTeamType: SystemTeamContributionTypes;
  systemLanguageType: Version["system_language_type"];
}

const VersionTeamDialog: React.FC<VersionTeamDialogProps> = ({
  controller,
  versionTeamType,
  systemLanguageType,
}) => {
  const versionTeamLogic = useVersionTeamConnectionLogic(
    controller.from,
    controller.to,
    versionTeamType,
    systemLanguageType
  );

  return (
    <ConnectionFormDialog<VersionTeamConnection, Version, Team>
      controller={controller}
      fromLabel="Version"
      fromEntityCollection={SystemEntityCollections.VERSION}
      toLabel="Team"
      toEntityCollection={SystemEntityCollections.TEAM}
      renderFromEntitySelection={renderVersionSelection(systemLanguageType)}
      renderToEntitySelection={renderTeamSelection(SystemLanguages.tibetan)}
    >
      {versionTeamLogic.showField("name") && (
        <FormTextField name="name" label="Name" placeholder="Enter Name" />
      )}

      {versionTeamLogic.showField("date") && (
        <IntellexusDateField name="date" label="Date" />
      )}

      {versionTeamLogic.showField("place") && (
        <FormEntitySelectionField<Place>
          name="place"
          label="Place"
          placeholder="Select place"
          entityCollection={SystemEntityCollections.PLACE}
          renderEntitySelection={renderPlaceSelection}
        />
      )}

      {versionTeamLogic.showField("place_identification_status") && (
        <FormSelectField
          name="place_identification_status"
          label="Place Identification Status"
          placeholder="Select identification status"
          useEnum={versionTeamLogic.teamContributionPlaceIdentificationStatusEnum}
        />
      )}

      {versionTeamLogic.showField("revision") && (
        <RevisionList name="revision" useEnum={versionTeamLogic.revisionEnum} />
      )}

      {versionTeamLogic.showField("title") && (
        <FormTextField name="title" label="Title" placeholder="Enter title" />
      )}

      {versionTeamLogic.showField("taisho_catalog_no") && (
        <FormTextField
          name="taisho_catalog_no"
          label="Taishō Catalog No."
          placeholder="Enter catalog number"
        />
      )}

      {versionTeamLogic.showField("source_language") && (
        <FormSelectField
          name="source_language"
          label="Source Language"
          placeholder="Select source language"
          useEnum={versionTeamLogic.chineseSourceLanguageEnum}
        />
      )}
    </ConnectionFormDialog>
  );
};

export default VersionTeamDialog;
